import React, { useState, useRef, useEffect } from 'react'
import _ from 'lodash'
import moment from 'moment-timezone'
import DateFnsUtils from '@date-io/date-fns'
import { Box, Typography, TextField } from '@material-ui/core'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useStyles } from './style'
import { AppButton } from '../../Components'

function DateTimePicker(props) {
  const classes = useStyles()
  const outerRef = useRef()
  const CONSTANT = {
    AM: 'AM',
    PM: 'PM',
    HOUR: 'HOUR',
    MIN: 'MIN',
    TYPE: 'TYPE',
    INCREMENT: 'INCREMENT',
    DECREMENT: 'DECREMENT',
    MODIFY: 'MODIFY'
  }
  const [hour, setHour] = useState('12')
  const [min, setMin] = useState('00')
  const [type, setType] = useState(CONSTANT.AM)
  const [date, setDate] = useState(props.value)

  useEffect(() => {
    const time = moment(props.value, props.format)
    setHour(time.format('hh') || '12')
    setMin(time.format('mm') || '00')
    setType(time.format('A') || CONSTANT.AM)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value])

  const handleOuterClick = (e) => {
    if (!outerRef.current.contains(e.target)) {
      props.handleCancel()
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleOuterClick)

    return () => {
      document.removeEventListener('mousedown', handleOuterClick)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleDoneClick = () => {
    const obj = {
      time: `${hour}:${min} ${type}`,
      date,
      dateTime: `${moment(date, 'MM-DD-YYYY').format('MM-DD-YYYY')} ${hour}:${min} ${type}`,
    }
    props.handleDone(obj)
  }

  const FormikDatePicker = () => {
    return (
      <DatePicker
        disableToolbar
        variant="static"
        format="dd-MM-yyyy"
        maxDate={props.maxDate}
        onChange={(value) => {
          setDate(value)
        }}
        minDate={props.minDate}
        value={moment(date, 'MM-DD-YYYY')}
        invalidLabel=''
        animateYearScrolling={false}
      />
    )
  }

  const convertToString = (num) => {
    return num.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
  }

  const handleTimeChange = (selection, action, value) => {
    switch (selection) {
      case CONSTANT.HOUR:
        let num = hour ? parseInt(hour) : 0
        if (action === CONSTANT.INCREMENT) {
          setHour(convertToString(num + 1 === 13 ? 1 : num + 1))
        } else if (action === CONSTANT.DECREMENT) {
          setHour(convertToString(num - 1 === 0 ? 12 : num - 1))
        } else {
          setHour(value > 12 ? 12 : value)
        }
        break
      case CONSTANT.MIN:
        let minValues = min ? parseInt(min) : 0
        if (action === CONSTANT.INCREMENT) {
          setMin(convertToString(minValues + 1 === 60 ? 0 : minValues + 1))
        } else if (action === CONSTANT.DECREMENT) {
          setMin(convertToString(minValues - 1 === -1 ? 59 : minValues - 1))
        } else {
          setMin(value < 0 ? 0 : value > 59 ? 0 : value)
        }
        break
      default:
        setType(type === CONSTANT.AM ? CONSTANT.PM : CONSTANT.AM)
    }
  }

  const handleOnBlur = (selection) => {
    if (selection === CONSTANT.HOUR) {
      if (hour === '' || _.isNaN(hour) || hour == 0) {
        setHour(12)
      } else {
        setHour(convertToString(hour))
      }
    } else {
      if (min === '' || _.isNaN(min)) {
        setMin(convertToString(0))
      } else {
        setMin(convertToString(min))
      }
    }
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Box className={classes.root} ref={outerRef}>
        <Box className={classes.calendarWrapper}>
          <Box>{FormikDatePicker()}</Box>
          <Box className={classes.timeWrapper}>
            <Box className={classes.time}>
              <Typography className={classes.pointer} onClick={() => handleTimeChange(CONSTANT.HOUR, CONSTANT.INCREMENT)}><ExpandLessIcon /></Typography>
              <Typography className={classes.boxWrap}>
                <TextField
                  InputProps={{
                    classes: { root: classes.input, underline: classes.underline },
                    type: 'number',
                  }}
                  classes={{ root: classes.inputWrapper }}
                  value={hour}
                  onChange={(e) => handleTimeChange(CONSTANT.HOUR, CONSTANT.MODIFY, parseInt(e.target.value))}
                  onBlur={() => handleOnBlur(CONSTANT.HOUR)}
                />
              </Typography>
              <Typography className={classes.pointer} onClick={() => handleTimeChange(CONSTANT.HOUR, CONSTANT.DECREMENT)}><ExpandMoreIcon /></Typography>
            </Box>
            <Typography>:</Typography>
            <Box className={classes.time}>
              <Typography className={classes.pointer} onClick={() => handleTimeChange(CONSTANT.MIN, CONSTANT.INCREMENT)}><ExpandLessIcon /></Typography>
              <Typography className={classes.boxWrap}>
                <TextField
                  InputProps={{
                    classes: { root: classes.input, underline: classes.underline },
                    type: 'number',
                  }}
                  classes={{ root: classes.inputWrapper }}
                  value={min}
                  onChange={(e) => handleTimeChange(CONSTANT.MIN, CONSTANT.MODIFY, parseInt(e.target.value))}
                  onBlur={() => handleOnBlur(CONSTANT.MIN)}
                />
              </Typography>
              <Typography className={classes.pointer} onClick={() => handleTimeChange(CONSTANT.MIN, CONSTANT.DECREMENT)}><ExpandMoreIcon /></Typography>
            </Box>
            <Box className={classes.time}>
              <Typography className={classes.pointer} onClick={() => handleTimeChange(CONSTANT.TYPE)}><ExpandLessIcon /></Typography>
              <Typography className={classes.boxWrap}>{type}</Typography>
              <Typography className={classes.pointer} onClick={() => handleTimeChange(CONSTANT.TYPE)}><ExpandMoreIcon /></Typography>
            </Box>
          </Box>
        </Box>
        <Box className={classes.buttonGroup}>
          <AppButton text='Cancel' onClick={props.handleCancel} fill={false} className={classes.button} />
          <AppButton text="Done" className={classes.button} onClick={handleDoneClick} />
        </Box>
      </Box>
    </MuiPickersUtilsProvider>
  )
}

DateTimePicker.defaultProps = {
  handleCancel: () => { },
  handleDone: () => { },
  minDate: '',
  maxDate: '',
  value: '',
  format: '',
  timezone: ''
}

export default DateTimePicker